module.exports = __webpack_public_path__ + "img/googleplay_button.5a4fc97b.png";